import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { Tooltip } from '../Tooltip/Tooltip.component.js';
import { propTypes, defaultProps } from './Chips.types.js';
import styles from './Chips.module.scss.js';

/**
 * A chips component
 *
 * Displays a stylized chips button
 */
var Chips = /** @class */ (function (_super) {
    __extends(Chips, _super);
    function Chips() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (event) {
            var _a = _this.props, isDisabled = _a.isDisabled, onClick = _a.onClick;
            if (isDisabled) {
                return;
            }
            onClick && onClick(event);
        };
        return _this;
    }
    Chips.prototype.render = function () {
        var _a = this.props, text = _a.text, prefixIcon = _a.prefixIcon, suffixIcon = _a.suffixIcon, isDisabled = _a.isDisabled, isSelected = _a.isSelected, className = _a.className, truncateText = _a.truncateText;
        var hasTooltip = text.length > Chips.MAX_TEXT_LENGTH && truncateText;
        var chipText = hasTooltip
            ? "".concat(text.slice(0, Chips.MAX_TEXT_LENGTH).trim(), "...")
            : text;
        var tooltipText = hasTooltip ? text : '';
        return (React__default.createElement(Tooltip, { variant: "topLeft", disabled: !hasTooltip, tooltipContent: tooltipText, tooltipClassName: styles.Chips_tooltip, hideArrow: true },
            React__default.createElement("button", { onClick: this.handleOnClick, disabled: isDisabled, className: "".concat(styles.Chips, " ").concat(isSelected ? styles.Chips___selected : '', " ").concat(className) },
                prefixIcon && (React__default.createElement("div", { className: styles.Chips_prefixIcon }, prefixIcon)),
                React__default.createElement("div", { className: styles.Chips_text }, chipText),
                suffixIcon && (React__default.createElement("div", { className: styles.Chips_suffixIcon }, suffixIcon)))));
    };
    Chips.displayName = 'Chips';
    Chips.propTypes = propTypes;
    Chips.defaultProps = __assign({}, defaultProps);
    //Design has shown Max Width in Nexus as being 280px aka ~13 characters
    Chips.MAX_TEXT_LENGTH = 14;
    return Chips;
}(React__default.Component));

export { Chips as default };
